import React from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import {Autocomplete} from "@material-ui/lab";
import {auditoriaEstandarResources} from "../endpoints";
import Box from "@material-ui/core/Box";

class DialogAuditoriaEstandar extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
            cumplimiento:[{valor:'0'},{valor:'100'}],
            observaciones_codificacion:[
                {descripcion:'TODOS LOS PRODUCTOS TIENEN CÓDIGO'},
                {descripcion:'LA MAYORÍA DE LOS PRODUCTOS TIENEN CÓDIGO'},
                {descripcion:'SOLO ALGUNOS PRODUCTOS TIENEN CÓDIGO'},
                {descripcion:'NINGÚN PRODUCTO TIENE CÓDIGO'}
            ],
            observacion_codificacion: "",
            cumplimiento_codificacion: "",
            comentarios_codificacion: "",
            observaciones_fleje:[
                {descripcion:'METRO CON TODOS LOS FLEJES CORRESPONDIENTES'},
                {descripcion:'LA MAYORÍA DE LOS FLEJES ESTÁN PUESTOS CORRECTAMENTE'},
                {descripcion:'SOLO TIENE ALGUNOS FLEJES'},
                {descripcion:'NO HAY FLEJES EN EL METRO'}
            ],
            observacion_fleje: "",
            cumplimiento_fleje: "",
            comentarios_fleje: "",
            observaciones_apantallamiento:[
                {descripcion:'EL METRO SE ENCUENTRA CORRECTAMENTE APANTALLADO'},
                {descripcion:'LA MAYORÍA DE LOS PRODUCTOS ESTÁN APANTALLADOS'},
                {descripcion:'ALGUNOS PRODUCTOS APANTALLADOS'},
                {descripcion:'METRO NO APANTALLADO'}
            ],
            observacion_apantallamiento: "",
            cumplimiento_apantallamiento: "",
            comentarios_apantallamiento: "",
            observaciones_merma:[
                {descripcion:'EL METRO NO TIENE PRODUCTOS MERMADOS'},
                {descripcion:'EXISTE UNA MERMA EN EL METRO'},
                {descripcion:'DE 2 A 3 PRODUCTOS MERMADOS EN METRO'},
                {descripcion:'MAS DE 3 MERMAS EN METRO'}
            ],
            observacion_merma: "",
            cumplimiento_merma: "",
            comentarios_merma: "",
            observaciones_verticalidad:[
                {descripcion:'EL METRO CUMPLE CON VERTICALIDAD'},
                {descripcion:'LA MAYORÍA DEL METRO CUMPLE CON VERTICALIDAD'},
                {descripcion:'SOLO ALGUNOS PRODUCTOS ORDENADOS'},
                {descripcion:'METRO DESORDENADO'}
            ],
            observacion_verticalidad: "",
            cumplimiento_verticalidad: "",
            comentarios_verticalidad: "",
            observaciones_planograma:[
                {descripcion:'METRO CUMPLE CON PLANOGRAMA'},
                {descripcion:'METRO EN SU MAYORÍA CUMPLE CON PLANOGRAMA'},
                {descripcion:'SOLO ALGUNOS PRODUCTOS ESTAN EN PLANOGRMA'},
                {descripcion:'NO CORRESPONDE A PLANOGRAMA'}
            ],
            observacion_planograma: "",
            cumplimiento_planograma: "",
            comentarios_planograma: ""
        }

    }

    handleChange = e =>{
        this.setState({[e.target.name]: e.target.value});
    }

    componentDidMount() {
        document.addEventListener('keyup', this.getEventType, false);
    }

    componentWillUnmount() {
        document.removeEventListener('keyup', this.getEventType, false);
    }

    getEventType = (event) =>{
        if(event.keyCode === 13){
            if(this.state.motivo && this.state.cantidad_final){

            }
        }
    }

    guardaAuditoria(){
        const datosAuditoria={
            observacion_codificacion: this.state.observacion_codificacion.descripcion,
            cumplimiento_codificacion: parseInt(this.state.cumplimiento_codificacion.valor),
            comentarios_codificacion: this.state.comentarios_codificacion,
            observacion_fleje: this.state.observacion_fleje.descripcion,
            cumplimiento_fleje: parseInt(this.state.cumplimiento_fleje.valor),
            comentarios_fleje: this.state.comentarios_fleje,
            observacion_apantallamiento: this.state.observacion_apantallamiento.descripcion,
            cumplimiento_apantallamiento: parseInt(this.state.cumplimiento_apantallamiento.valor),
            comentarios_apantallamiento: this.state.comentarios_apantallamiento,
            observacion_merma: this.state.observacion_merma.descripcion,
            cumplimiento_merma: parseInt(this.state.cumplimiento_merma.valor),
            comentarios_merma: this.state.comentarios_merma,
            observacion_verticalidad: this.state.observacion_verticalidad.descripcion,
            cumplimiento_verticalidad: parseInt(this.state.cumplimiento_verticalidad.valor),
            comentarios_verticalidad: this.state.comentarios_verticalidad,
            observacion_planograma: this.state.observacion_planograma.descripcion,
            cumplimiento_planograma: parseInt(this.state.cumplimiento_planograma.valor),
            comentarios_planograma: this.state.comentarios_planograma
        }
        auditoriaEstandarResources.createAuditoria(datosAuditoria).then(async response => {
            if (response) {
                return await response.json();
            }
        }).then(result=> {
            if(result.message){
                this.props.refrescar(result.message,result.severity)
            }
            else{
                throw new Error('Something went wrong ...');
            }
        }).catch(error=> {
            console.log(error)
            this.props.refrescar("Ha ocurrido un error inesperado", "error")
        });
    }

    render() {
        return(
            <Dialog
                open={true}
                fullWidth
                maxWidth={"md"}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description">
                <DialogTitle id="alert-dialog-title">Auditoria estándar</DialogTitle>
                <DialogContent>
                    <Grid container spacing={2} alignItems="flex-end">
                        Codificación:
                        <Grid container item xs={12} spacing={2}>
                            <Grid item xs={5}>
                                <Autocomplete
                                    onChange={(event, newValue) => {
                                        if(newValue === null) {
                                            this.setState({cumplimiento_codificacion: ""})
                                        }
                                        else{
                                            this.setState({cumplimiento_codificacion: newValue})
                                        }
                                    }}
                                    size="small"
                                    options={this.state.cumplimiento}
                                    noOptionsText={"No hay opciones"}
                                    getOptionLabel={(option) => option.valor|| ""}
                                    renderInput={(params) => (
                                        <TextField {...params} variant="standard" label="Cumplimiento" placeholder="Disponibles" />
                                    )} />
                            </Grid>
                            <Grid item xs={7}>
                                <Autocomplete
                                    onChange={(event, newValue) => {
                                        if(newValue === null) {
                                            this.setState({observacion_codificacion: ""})
                                        }
                                        else{
                                            this.setState({observacion_codificacion: newValue})
                                        }
                                    }}
                                    size="small"
                                    options={this.state.observaciones_codificacion}
                                    noOptionsText={"No hay opciones"}
                                    getOptionLabel={(option) => option.descripcion|| ""}
                                    renderInput={(params) => (
                                        <TextField {...params} variant="standard" label="Observación Codificacion" placeholder="Disponibles" />
                                    )}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <Box sx={{width: 500, maxWidth: '100%',}}>
                                    <TextField
                                        id="standard-multiline-flexible"
                                        label="Comentarios"
                                        multiline
                                        fullWidth
                                        rowsMax={5}
                                        name={"comentarios_codificacion"}
                                        value={this.state.comentarios_codificacion}
                                        onChange={this.handleChange}
                                    />
                                </Box>
                            </Grid>
                        </Grid>
                        <br/>
                        Fleje:
                        <Grid container item xs={12} spacing={2}>
                            <Grid item xs={5}>
                                <Autocomplete
                                    onChange={(event, newValue) => {
                                        if(newValue === null) {
                                            this.setState({cumplimiento_fleje: ""})
                                        }
                                        else{
                                            this.setState({cumplimiento_fleje: newValue})
                                        }
                                    }}
                                    size="small"
                                    options={this.state.cumplimiento}
                                    noOptionsText={"No hay opciones"}
                                    getOptionLabel={(option) => option.valor|| ""}
                                    renderInput={(params) => (
                                        <TextField {...params} variant="standard" label="Cumplimiento" placeholder="Disponibles" />
                                    )} />
                            </Grid>
                            <Grid item xs={7}>
                                <Autocomplete
                                    onChange={(event, newValue) => {
                                        if(newValue === null) {
                                            this.setState({observacion_fleje: ""})
                                        }
                                        else{
                                            this.setState({observacion_fleje: newValue})
                                        }
                                    }}
                                    size="small"
                                    options={this.state.observaciones_fleje}
                                    noOptionsText={"No hay opciones"}
                                    getOptionLabel={(option) => option.descripcion|| ""}
                                    renderInput={(params) => (
                                        <TextField {...params} variant="standard" label="Observación Fleje" placeholder="Disponibles" />
                                    )}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <Box sx={{width: 500, maxWidth: '100%',}}>
                                    <TextField
                                        id="standard-multiline-flexible"
                                        label="Comentarios"
                                        multiline
                                        fullWidth
                                        rowsMax={5}
                                        name={"comentarios_fleje"}
                                        value={this.state.comentarios_fleje}
                                        onChange={this.handleChange}
                                    />
                                </Box>
                            </Grid>
                        </Grid>
                        <br/>
                        Apantallamiento:
                        <Grid container item xs={12} spacing={2}>
                            <Grid item xs={5}>
                                <Autocomplete
                                    onChange={(event, newValue) => {
                                        if(newValue === null) {
                                            this.setState({cumplimiento_apantallamiento: ""})
                                        }
                                        else{
                                            this.setState({cumplimiento_apantallamiento: newValue})
                                        }
                                    }}
                                    size="small"
                                    options={this.state.cumplimiento}
                                    noOptionsText={"No hay opciones"}
                                    getOptionLabel={(option) => option.valor|| ""}
                                    renderInput={(params) => (
                                        <TextField {...params} variant="standard" label="Cumplimiento" placeholder="Disponibles" />
                                    )} />
                            </Grid>
                            <Grid item xs={7}>
                                <Autocomplete
                                    onChange={(event, newValue) => {
                                        if(newValue === null) {
                                            this.setState({observacion_apantallamiento: ""})
                                        }
                                        else{
                                            this.setState({observacion_apantallamiento: newValue})
                                        }
                                    }}
                                    size="small"
                                    options={this.state.observaciones_apantallamiento}
                                    noOptionsText={"No hay opciones"}
                                    getOptionLabel={(option) => option.descripcion|| ""}
                                    renderInput={(params) => (
                                        <TextField {...params} variant="standard" label="Observación Apantallamiento" placeholder="Disponibles" />
                                    )}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <Box sx={{width: 500, maxWidth: '100%',}}>
                                    <TextField
                                        id="standard-multiline-flexible"
                                        label="Comentarios"
                                        multiline
                                        fullWidth
                                        rowsMax={5}
                                        name={"comentarios_apantallamiento"}
                                        value={this.state.comentarios_apantallamiento}
                                        onChange={this.handleChange}
                                    />
                                </Box>
                            </Grid>
                        </Grid>
                        <br/>
                        Merma:
                        <Grid container item xs={12} spacing={2}>
                            <Grid item xs={5}>
                                <Autocomplete
                                    onChange={(event, newValue) => {
                                        if(newValue === null) {
                                            this.setState({cumplimiento_merma: ""})
                                        }
                                        else{
                                            this.setState({cumplimiento_merma: newValue})
                                        }
                                    }}
                                    size="small"
                                    options={this.state.cumplimiento}
                                    noOptionsText={"No hay opciones"}
                                    getOptionLabel={(option) => option.valor|| ""}
                                    renderInput={(params) => (
                                        <TextField {...params} variant="standard" label="Cumplimiento" placeholder="Disponibles" />
                                    )} />
                            </Grid>
                            <Grid item xs={7}>
                                <Autocomplete
                                    onChange={(event, newValue) => {
                                        if(newValue === null) {
                                            this.setState({observacion_merma: ""})
                                        }
                                        else{
                                            this.setState({observacion_merma: newValue})
                                        }
                                    }}
                                    size="small"
                                    options={this.state.observaciones_merma}
                                    noOptionsText={"No hay opciones"}
                                    getOptionLabel={(option) => option.descripcion|| ""}
                                    renderInput={(params) => (
                                        <TextField {...params} variant="standard" label="Observación Merma" placeholder="Disponibles" />
                                    )}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <Box sx={{width: 500, maxWidth: '100%',}}>
                                    <TextField
                                        id="standard-multiline-flexible"
                                        label="Comentarios"
                                        multiline
                                        fullWidth
                                        rowsMax={5}
                                        name={"comentarios_merma"}
                                        value={this.state.comentarios_merma}
                                        onChange={this.handleChange}
                                    />
                                </Box>
                            </Grid>
                        </Grid>
                        <br/>
                        Verticalidad:
                        <Grid container item xs={12} spacing={2}>
                            <Grid item xs={5}>
                                <Autocomplete
                                    onChange={(event, newValue) => {
                                        if(newValue === null) {
                                            this.setState({cumplimiento_verticalidad: ""})
                                        }
                                        else{
                                            this.setState({cumplimiento_verticalidad: newValue})
                                        }
                                    }}
                                    size="small"
                                    options={this.state.cumplimiento}
                                    noOptionsText={"No hay opciones"}
                                    getOptionLabel={(option) => option.valor|| ""}
                                    renderInput={(params) => (
                                        <TextField {...params} variant="standard" label="Cumplimiento" placeholder="Disponibles" />
                                    )} />
                            </Grid>
                            <Grid item xs={7}>
                                <Autocomplete
                                    onChange={(event, newValue) => {
                                        if(newValue === null) {
                                            this.setState({observacion_verticalidad: ""})
                                        }
                                        else{
                                            this.setState({observacion_verticalidad: newValue})
                                        }
                                    }}
                                    size="small"
                                    options={this.state.observaciones_verticalidad}
                                    noOptionsText={"No hay opciones"}
                                    getOptionLabel={(option) => option.descripcion|| ""}
                                    renderInput={(params) => (
                                        <TextField {...params} variant="standard" label="Observación  Verticalidad" placeholder="Disponibles" />
                                    )}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <Box sx={{width: 500, maxWidth: '100%',}}>
                                    <TextField
                                        id="standard-multiline-flexible"
                                        label="Comentarios"
                                        multiline
                                        fullWidth
                                        rowsMax={5}
                                        name={"comentarios_verticalidad"}
                                        value={this.state.comentarios_verticalidad}
                                        onChange={this.handleChange}
                                    />
                                </Box>
                            </Grid>
                        </Grid>
                        <br/>
                        Planograma:
                        <Grid container item xs={12} spacing={2}>
                            <Grid item xs={5}>
                                <Autocomplete
                                    onChange={(event, newValue) => {
                                        if(newValue === null) {
                                            this.setState({cumplimiento_planograma: ""})
                                        }
                                        else{
                                            this.setState({cumplimiento_planograma: newValue})
                                        }
                                    }}
                                    size="small"
                                    options={this.state.cumplimiento}
                                    noOptionsText={"No hay opciones"}
                                    getOptionLabel={(option) => option.valor|| ""}
                                    renderInput={(params) => (
                                        <TextField {...params} variant="standard" label="Cumplimiento" placeholder="Disponibles" />
                                    )} />
                            </Grid>
                            <Grid item xs={7}>
                                <Autocomplete
                                    onChange={(event, newValue) => {
                                        if(newValue === null) {
                                            this.setState({observacion_planograma: ""})
                                        }
                                        else{
                                            this.setState({observacion_planograma: newValue})
                                        }
                                    }}
                                    size="small"
                                    options={this.state.observaciones_planograma}
                                    noOptionsText={"No hay opciones"}
                                    getOptionLabel={(option) => option.descripcion|| ""}
                                    renderInput={(params) => (
                                        <TextField {...params} variant="standard" label="Observación  Planograma" placeholder="Disponibles" />
                                    )}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <Box sx={{width: 500, maxWidth: '100%',}}>
                                    <TextField
                                        id="standard-multiline-flexible"
                                        label="Comentarios"
                                        multiline
                                        fullWidth
                                        rowsMax={5}
                                        name={"comentarios_planograma"}
                                        value={this.state.comentarios_planograma}
                                        onChange={this.handleChange}
                                    />
                                </Box>
                            </Grid>
                        </Grid>
                        <br/>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button variant="contained" color="secondary" onClick={this.props.handleClose}>
                        Cancelar
                    </Button>
                    <Button disabled={!this.state.cumplimiento_codificacion || !this.state.cumplimiento_verticalidad || !this.state.cumplimiento_merma
                        || !this.state.cumplimiento_fleje || !this.state.cumplimiento_apantallamiento || !this.state.cumplimiento_planograma
                        ||!this.state.observacion_codificacion || !this.state.observacion_apantallamiento || !this.state.observacion_fleje
                        || !this.state.observacion_merma || !this.state.observacion_verticalidad || !this.state.observacion_planograma}
                            variant="contained" onClick={()=>{this.guardaAuditoria()}} color="primary">
                        Guardar
                    </Button>
                </DialogActions>
            </Dialog>
        )
    }
}

export default DialogAuditoriaEstandar;